<div class="blog-top">
   <div class="container top-title">
  <div class="title">Blog</div>
  <div class="b-title">
    <div class="slogan">Size özel yayınladığımız yazılar</div>
   
  </div>
</div></div>
<div class="container">
 
<div class="row">
  <div *ngIf="blogDetail" class="blog-detail">
    <div class="small-text">
      <a [routerLink]="['/blog']">
  
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="16"
              viewBox="0 0 21 16"
              fill="none"
              transform="rotate(180)"
            >
              <path
                d="M20.8001 7.48984L13.9222 0.252973C13.6751 -0.0505841 13.2409 -0.085971 12.9524 0.174052C12.6639 0.434013 12.6303 0.890873 12.8774 1.19443C12.9004 1.22273 12.9255 1.24916 12.9524 1.27335L18.6542 7.27994H1.10867C0.728848 7.27994 0.420898 7.60396 0.420898 8.00367C0.420898 8.40337 0.728848 8.72733 1.10867 8.72733H18.6542L12.9524 14.7266C12.6639 14.9866 12.6303 15.4435 12.8774 15.747C13.1245 16.0506 13.5587 16.086 13.8472 15.8259C13.8741 15.8017 13.8992 15.7753 13.9222 15.747L20.8001 8.51016C21.0668 8.22799 21.0668 7.77213 20.8001 7.48984Z"
                fill="#051215"
              />
            </svg>Tüm Yazılar</a>
          </div> 
    
    <app-img-view class="img" [imageUrl]="blogDetail.imageUrl"></app-img-view>
    <div class="tag" *ngIf="tags.length>0">
      <span *ngFor="let tag of tags">{{ tag }}</span>
    </div>
    <h1>{{ blogDetail.title }}</h1>
    <h6>{{ blogDetail.createdDate }}</h6>
    <div class="blog-content" [innerHTML]="blogDetail.content"></div>
  </div>
</div>
  
</div>